"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginTypes = exports.SessionTokenTypes = void 0;
var SessionTokenTypes;
(function (SessionTokenTypes) {
    SessionTokenTypes["apikey"] = "apikey";
    SessionTokenTypes["login_code"] = "login_code";
    SessionTokenTypes["sessiontoken"] = "sessiontoken";
    SessionTokenTypes["passwordreset"] = "passwordreset";
    SessionTokenTypes["teaminvitation"] = "teaminvitation";
    SessionTokenTypes["adminsessiontoken"] = "adminsessiontoken";
    SessionTokenTypes["email_comfirmation"] = "email_comfirmation";
})(SessionTokenTypes || (exports.SessionTokenTypes = SessionTokenTypes = {}));
var LoginTypes;
(function (LoginTypes) {
    LoginTypes["LINK"] = "link";
    LoginTypes["EMAIL"] = "email";
    LoginTypes["GOOGLE"] = "google";
    // FACEBOOK = "facebook",
})(LoginTypes || (exports.LoginTypes = LoginTypes = {}));
